import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { ApiProjectService } from '../api-services/project.api.service';
import { ApiSceneService } from '../api-services/scene.api.service';
import { AssetInScene } from '../models/AssetInScene';
import { VrEventService } from './vr-event.service';
import { ApiAssetOnAssetManagementPageService } from '../api-services/asset-on-management-page.api.service';
import { ApiAssetService } from '../api-services/asset.api.service';
import { BaseAsset } from '../models/assets/baseAsset';
import { ApiSceneAssetRelationService } from '../api-services/scene-asset-relation.api.service';
import { AssetTypeService } from './asset-type.service';
import { SceneAssetRelation } from '../models/scene-asset-relations/SceneAssetRelation';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { AssetEvent } from '../models/vr-events/AssetEvent';
import { VrEvent } from '../models/vr-events/VrEvent';
import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { VrEventAssetRelation } from '../models/vr-events/VrEventAssetRelation';
import { ApiVrEventAssetRelationService } from '../api-services/vr-event-asset-relation.api.service';
import { ApiVrEventSceneRelationService } from '../api-services/vr-event-scene-relation.api.service';
import { QuestionResponse } from '../models/assets/QuestionResponse';
import { ApiQuestionResponseService } from '../api-services/question-response.api.service';
import { Project } from '../models/project';
import { Scene } from '../models/Scene';
import { VrEventSceneRelation } from '../models/vr-events/VrEventSceneRelation';
import { AssetInBaseAsset } from '../models/assets-in-base-asset/AssetInBaseAsset';
import { ApiAssetInBaseAssetService } from '../api-services/asset-in-base-asset.api.service';
import { ApiQuestionRuleService } from '../api-services/question-rule.api.service';
import { QuestionRule } from '../models/question-rules/QuestionRule';
import { FileService } from './file.service';
import { MediaAsset } from '../models/assets/MediaAsset';
import { DeepCopyService } from './deep-copy.service';
import { ApiAssetInQuestionResponseService } from '../api-services/asset-in-question-response.api.service';
import { AssetInQuestionResponse } from '../models/assets-in-base-asset/AssetInQuestionResponse';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { OutcomeActionService } from './outcome-action.service';
import { CryptoService } from './crypto.service';
import { StorageService } from './storageService.service';


@Injectable({
  providedIn: 'root'
})
export class SaveService {

  public scenes: Scene[] = [];
  public saveProjectComplete: boolean = false;
  public savingTimeout = null;
  public savingTimeoutVal: number = 120000;
  public lastError: string = "";


  constructor(public apiProjectService: ApiProjectService,
    public sceneAPIService: ApiSceneService,
    public assetAPIService: ApiAssetService,
    public VrEventAPIService: ApiVrEventService,
    public responseAPIService: ApiQuestionResponseService,
    public VrEventAssetRelationAPIService: ApiVrEventAssetRelationService,
    public VrEventSceneRelationAPIService: ApiVrEventSceneRelationService,
    public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
    public assetManagePageAPIService: ApiAssetOnAssetManagementPageService,
    public VrEventService: VrEventService,
    public assetTypeService: AssetTypeService,
    public assetInBaseAssetAPIService: ApiAssetInBaseAssetService,
    public questionRuleAPIService: ApiQuestionRuleService,
    public fileService: FileService,
    public deepCopyService: DeepCopyService,
    public assetInQuestionResponseAPIService: ApiAssetInQuestionResponseService,
    public outcomeActionService: OutcomeActionService,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }

  saveProject(project: Project, scenes: Scene[], assetsInScene: AssetInScene[]): Promise<Project> {
    return new Promise<Project>(async (resolve, reject) => {
      this.saveProjectComplete = false;
      this.scenes = scenes;

      try{
        await this.updateScenes();
        await this.deleteAssets(this.getAssetsToBeRemoved(assetsInScene));
        await this.saveAssets(assetsInScene);
        await this.updateProjectTimestamp(project).then(async x => {
          await this.apiProjectService.getProject(project.projectId).subscribe(x => {
            this.setProject(x);
            project.timeStamp = x.timeStamp;
            project.projectSize = x.projectSize;
            project.usageValue = x.usageValue;
  
            resolve(project);
          },
          err =>{
            reject(err);
          });
        }).catch(err =>{
          console.log("update project error 2", err)
          reject(err);
        });
      }catch(err){
        reject(this.lastError);
      }
    });
  }

  setProject(project) {
    this.storageService.setItem('project', this.cryptoService.encryptData(JSON.stringify(project)));
  }

  updateProjectTimestamp(project: Project): Promise<Project> {
    // This updates the project's timeStamp so it appears in the more recent project section on the dashboard.
    return new Promise<Project>((resolve, reject) => this.apiProjectService.updateProject(project.projectId, project).subscribe(result => resolve(result), err => reject(err)))
  }

  updateScenes(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try{
        for (var scene of this.scenes) {
          await new Promise<void>(async (resolve, reject) => {
            let sceneToDb = this.deepCopyService.deepCopy(scene);
            
            let videoToCheck =this.fileService.getVideoToCheck('scene', sceneToDb.sceneId)
            if(videoToCheck){
              sceneToDb.uploadStatus = videoToCheck.uploadStatus;
              sceneToDb.sceneBackgroundFileSize = videoToCheck.fileSize;
              sceneToDb.sceneBackgroundSrc = videoToCheck.src;
            }
    
            this.updateSceneToDb(sceneToDb).then(result => {
              resolve();
            }).catch(err => {
              reject(err);
            });
          }).catch(err =>{
            console.log("error update scenes", err)
            reject(err)
          });
          //this.updateSceneEvents(scene);
        }
        resolve();
      }catch(err) {
        this.lastError = "Something wrong happened saving the scenes";
        reject(err);
      }
    });
  }

  updateSceneToDb(scene: Scene): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.sceneAPIService.updateScene(scene.sceneId, scene).subscribe(res => {
        resolve(true);
      },
      err => {
        resolve(true);
      });
    });
  }

  updateSceneEventsAndOutcomeActions(scene: Scene): Promise<void> {
    console.log(scene);
    return new Promise<void>((resolve) => {
      this.updateSceneEvents(scene).then(async () => {
        for (let i: number = 0; i < scene.outcomeActions.length; i++) {
          let outcomeAction = scene.outcomeActions[i];
          await this.outcomeActionService.addOutcomesAction(outcomeAction);
        }
        resolve();
      });
    });
  }

  updateSceneEvents(scene: Scene): Promise<void> {
    return new Promise<void>((resolve) => {
      if (scene.events && scene.events.length > 0) {
        let count: number = 0;
        scene.events.forEach(event => {
          if (event.vrEventId == 0) {
            this.VrEventAPIService.addSceneEvent(event).subscribe(sceneEvent => {
              let relation: VrEventSceneRelation = {
                'sceneId': scene.sceneId,
                'vrEventId': sceneEvent.vrEventId,
                'vrEventSceneRelationId': 0
              }
              this.VrEventSceneRelationAPIService.addVrEventSceneRelation(relation).subscribe(rrEventSceneRelation => {
                count++;
                if (count == scene.events.length)
                  resolve();
              });
            },
            err => {
              resolve();
            });
          }
        });
      } else {
        resolve();
      }
    });
  }

  deleteAssets(assetsToBeRemoved: AssetInScene[]): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try{
        for (let i: number = 0; i < assetsToBeRemoved.length; i++) {
          let assetToBeRemoved = assetsToBeRemoved[i];
          await this.deleteAsset(assetToBeRemoved);
          assetToBeRemoved.removed = true;
          await this.deleteAssetInBaseAsset(assetToBeRemoved);
          await this.deleteAssetInQuestionResponseWithSceneAssetRelationId(assetToBeRemoved);
        }
        resolve();
      }catch(err){
        this.lastError = "Something wrong happened when deleting the assets"
        reject(err);
      }
    });
  }

  saveAssets(assetsInScene: AssetInScene[]): Promise<void> {
    // if asset has baseAssetId then it is in db already.
    // if has toBeRemoved then delete asset
    return new Promise(async (resolve, reject) => {
      //No need to save assets now;
      resolve();
      return;
      try{
        let i: number = 0;

        for(let j = 0; j < assetsInScene.length; j++){
          let asset = assetsInScene[j]

          if(["Question", "QuestionSet"].includes(this.assetTypeService.getType(asset.baseAsset.assetTypeId))){
            i++;
            if (i == assetsInScene.length) {
              resolve();
            }
            return;
          }
          
          if (this.shouldAssetBeRemoved(asset)) {
            i++;
            if (i == assetsInScene.length) {
              resolve();
            }
          } else if (!asset.toBeRemoved) {
            if(this.scenes.find(s => s.active == true && s.sceneId == asset.sceneAssetRelation.sceneId)){
              await this.addOrUpdateAssetInScene(asset);
            }          
            i++;
            if (i == assetsInScene.length) {
              resolve();
            }
          } else {
            i++;
            if (i == assetsInScene.length) {
              resolve();
            }
          }
        }
        if (i == assetsInScene.length) {
          resolve();
        }
      }catch(err){
        console.error("Error saving media!");
        this.lastError = "Something wrong happened when saving the media";
        reject(err);
      }
    });
  }

  addOrUpdateAssetInScene(assetInScene: AssetInScene): Promise<AssetInScene>{
    return new Promise<AssetInScene>((resolve, reject) => {
      this.assetAPIService.addOrUpdateAssetInScene(assetInScene).subscribe(result => {
        assetInScene.baseAsset = result.baseAsset;
        for(var k in result.sceneAssetRelation) assetInScene.sceneAssetRelation[k] = result.sceneAssetRelation[k];
        assetInScene.events = result.events;
        assetInScene.outcomeActions = result.outcomeActions;
        assetInScene.questionRules = result.questionRules;
        assetInScene.assets = result.assets;

        resolve(assetInScene);
      },
      err =>{
        console.log("error addupdate asset", err)
        reject(err)
      });
    });    
  }

  addOrUpdateAsset(assetInScene: AssetInScene): Promise<SceneAssetRelation> {
    if (!assetInScene.baseAsset.baseAssetId) {
      // Once the asset is added to the database, it is returned as a promise      
      var assetResultPromise = this.addAssetToDb(assetInScene);

      // Once the sceneAssetResult is added to the database, it is returned as a promise
      var sceneAssetRelationPromise = this.addSceneAssetRelationToDbWithPromise(assetInScene, assetResultPromise);

      this.addOutcomeActionsToDb(assetInScene, sceneAssetRelationPromise);
      this.addEventsAndEventRelationsToDb(assetInScene, sceneAssetRelationPromise);
      this.addQuestionRulesToDb(assetInScene, sceneAssetRelationPromise);

      return sceneAssetRelationPromise;
    } else {
      var assetResultPromise = this.updateAssetInDb(assetInScene);
      var sceneAssetRelationPromise = this.addOrUpdateSceneAssetRelation(assetInScene);

      assetInScene.events.forEach(assetEvent => {
        if (!assetEvent.vrEventId) {
          var VrEventPromise = this.addVrEventToDb(assetEvent, sceneAssetRelationPromise);
          this.addVrEventAssetRelationToDb(assetEvent, VrEventPromise);
        }
      });

      if (assetInScene.outcomeActions) {
        assetInScene.outcomeActions.forEach(async outcomeAction => {
          if (!outcomeAction.outcomeActionId || outcomeAction.outcomeActionId == 0) {
            outcomeAction.sceneAssetRelationId = assetInScene.sceneAssetRelation.sceneAssetRelationId;
            await this.outcomeActionService.addOutcomesAction(outcomeAction);
          }
        });
      }

      if (assetInScene.questionRules) {
        assetInScene.questionRules.forEach((questionRule: QuestionRule) => {
          if (!questionRule.toBeRemoved) {
            questionRule.toBeRemoved = false;
          }
          if ((!questionRule.questionRuleId || questionRule.questionRuleId == 0) && questionRule.toBeRemoved == false) {
            this.addQuestionRuleToDb(questionRule, sceneAssetRelationPromise);
          } else if (questionRule.questionRuleId && questionRule.questionRuleId > 0 && questionRule.toBeRemoved == false) {
            this.updateQuestionRuleToDb(questionRule);
          } else if (questionRule.questionRuleId && questionRule.questionRuleId > 0 && questionRule.toBeRemoved == true) {
            this.deleteQuestionRuleToDb(questionRule);
          }
        });
      }

      return sceneAssetRelationPromise;
    }
  }

  addOrUpdateAllSceneAssetRelations(assetsInScene: AssetInScene[]): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      for (let i: number = 0; i < assetsInScene.length; i++) {
        let assetInScene = assetsInScene[i];

        //RESET EVENTS, QUESTION RULES AND OUTCOME ACTIONS ON COPY;
        let events = assetInScene.events;
        let questionRules = assetInScene.questionRules;
        let outcomeActions = assetInScene.outcomeActions;
        let assetInAssetEvents = [];
        let assetInAssetQuestionRules = [];
        let assetInAssetOutcomeActions = [];

        assetInScene.events = [];
        assetInScene.questionRules = [];
        assetInScene.outcomeActions = [];
        for(let j: number = 0; j < assetInScene.assets.length; j++){
          let assetInAsset = assetInScene.assets[j];
          assetInAssetEvents.push(this.deepCopyService.deepCopy(assetInAsset.events));
          assetInAssetQuestionRules.push(this.deepCopyService.deepCopy(assetInAsset.questionRules));
          assetInAssetOutcomeActions.push(this.deepCopyService.deepCopy(assetInAsset.outcomeActions));

          assetInAsset.events = [];
          assetInAsset.questionRules = [];
          assetInAsset.outcomeActions = [];
        }
        
        await this.addOrUpdateAssetInScene(assetInScene);

        assetInScene.events = events;
        assetInScene.questionRules = questionRules;
        assetInScene.outcomeActions = outcomeActions;
        for(let j: number = 0; j < assetInScene.assets.length; j++){
          let assetInAsset = assetInScene.assets[j];

          assetInAsset.events = this.deepCopyService.deepCopy(assetInAssetEvents[j]);
          assetInAsset.questionRules = this.deepCopyService.deepCopy(assetInAssetQuestionRules[j]);
          assetInAsset.outcomeActions = this.deepCopyService.deepCopy(assetInAssetOutcomeActions[j]);
        }
        /*if (!assetInScene.baseAsset.baseAssetId) {
          var assetResultPromise = this.addAssetToDb(assetInScene);
          await this.addSceneAssetRelationToDbWithPromise(assetInScene, assetResultPromise);
        } else {
          var assetResultPromise = this.updateAssetInDb(assetInScene);
          await this.addOrUpdateSceneAssetRelation(assetInScene);
        }
        if (assetInScene.assets) {
          await this.addOrUpdateAllSceneAssetRelations(assetInScene.assets);
          for (let j: number = 0; j < assetInScene.assets.length; j++) {
            var assetInAsset = assetInScene.assets[j];
            this.addOrUpdateAssetInBaseAsset(assetInAsset.baseAsset, assetInScene.baseAsset, j);
          }
        }*/
      }
      resolve(true);
    });
  }

  addOrUpdateAssetInBaseAsset(baseAsset: BaseAsset, linkedBaseAsset: BaseAsset, index: number): Promise<AssetInBaseAsset> {
    return new Promise<AssetInBaseAsset>(async (resolve, reject) => {
      var assetsInBaseAsset = await this.assetInBaseAssetAPIService.getAssetsInBaseAssetWithBaseAssetId(baseAsset.baseAssetId).toPromise();
      if (assetsInBaseAsset.length == 0) {
        var assetInBaseAsset = new AssetInBaseAsset();
        assetInBaseAsset.baseAssetId = baseAsset.baseAssetId;
        assetInBaseAsset.linkedBaseAssetId = linkedBaseAsset.baseAssetId;
        assetInBaseAsset.assetInBaseAssetIndex = index;
        this.addAssetInBaseAssetToDb(assetInBaseAsset).then(assetInBaseAssetResult => {
          resolve(assetInBaseAssetResult);
        });
      } else {
        assetsInBaseAsset[0].baseAssetId = baseAsset.baseAssetId;
        assetsInBaseAsset[0].linkedBaseAssetId = linkedBaseAsset.baseAssetId;
        assetsInBaseAsset[0].assetInBaseAssetIndex = index;
        this.updateAssetInBaseAssetToDb(assetsInBaseAsset[0]).then(assetInBaseAssetResult => {
          resolve(assetInBaseAssetResult);
        });
      }
    });
  }

  addOrReturnAssetInQuestionResponse(asset: AssetInScene, linkedQuestionResponse: QuestionResponse, index: number): Promise<AssetInQuestionResponse> {
    return new Promise<AssetInQuestionResponse>(async (resolve, reject) => {
      let assetsInQuestionResponse = await this.assetInQuestionResponseAPIService.getAssetsInQuestionResponseWithSceneAssetRelationId(asset.sceneAssetRelation.sceneAssetRelationId).toPromise();
      if (assetsInQuestionResponse.length == 0) {
        let assetInQuestionResponse = new AssetInQuestionResponse();
        assetInQuestionResponse.baseAssetId = asset.baseAsset.baseAssetId;
        assetInQuestionResponse.sceneAssetRelationId = asset.sceneAssetRelation.sceneAssetRelationId;
        assetInQuestionResponse.linkedQuestionResponseId = linkedQuestionResponse.questionResponseId;
        assetInQuestionResponse.assetInQuestionResponseIndex = index;
        this.addAssetInQuestionResponseToDb(assetInQuestionResponse).then(assetInBaseAssetResult => {
          resolve(assetInBaseAssetResult);
        });
      } else {
        resolve(assetsInQuestionResponse.find(a => a.sceneAssetRelationId == asset.sceneAssetRelation.sceneAssetRelationId));
      }
    });
  }

  addAssetToDb(assetInScene: AssetInScene): Promise<BaseAsset> {
    var assetType = this.getType(assetInScene.baseAsset.assetTypeId);
    return new Promise((resolve, reject) => {
      let assetToDb = this.deepCopyService.deepCopy(assetInScene.baseAsset);
      if (assetType == 'Video') {
        if (this.fileService.getObjectSrc('baseAsset', assetInScene.sceneAssetRelation.sceneAssetRelationId))
          assetToDb.src = this.fileService.getObjectSrc('baseAsset', assetInScene.sceneAssetRelation.sceneAssetRelationId);
      }
      this.assetAPIService.addAsset(assetToDb, assetType).subscribe(assetResult => {
        assetInScene.baseAsset.baseAssetId = assetResult.baseAssetId;
        if (assetType == 'Question') {
          this.addQuestionResponsesToDb(assetInScene, assetResult.baseAssetId);
        }
        resolve(assetResult as BaseAsset);
      },
      err => {
        resolve(null);
      });
    });
  }

  addSceneAssetRelationToDbWithPromise(assetInScene: AssetInScene, assetResultPromise): Promise<SceneAssetRelation> {
    return new Promise((resolve, reject) => {
      assetResultPromise.then(assetResult => {
        resolve(this.addSceneAssetRelationToDb(assetInScene, assetResult));
      });
    });
  }

  addEventsAndEventRelationsToDb(assetInScene, sceneAssetRelationPromise) {
    assetInScene.events.forEach(assetEvent => {
      var VrEventPromise = this.addVrEventToDb(assetEvent, sceneAssetRelationPromise);
      this.addVrEventAssetRelationToDb(assetEvent, VrEventPromise);
    });
  }

  addQuestionRulesToDb(assetInScene, sceneAssetRelationPromise: Promise<SceneAssetRelation>) {
    if (assetInScene.questionRules) {
      assetInScene.questionRules.forEach(questionRule => {
        this.addQuestionRuleToDb(questionRule, sceneAssetRelationPromise);
      });
    }
  }

  addQuestionRuleToDb(questionRule: QuestionRule, sceneAssetRelationPromise: Promise<SceneAssetRelation>) {
    sceneAssetRelationPromise.then(sceneAssetRelationResult => {
      questionRule.sceneAssetRelationId = sceneAssetRelationResult.sceneAssetRelationId;
      this.questionRuleAPIService.addQuestionRule(questionRule).subscribe(questionRuleResult => {
        questionRule.questionRuleId = questionRuleResult.questionRuleId;
      });
    });
  }

  addQuestionRuleToDbWithoutPromise(questionRule: QuestionRule): Promise<QuestionRule> {
    return new Promise<QuestionRule>((resolve) => {
      this.questionRuleAPIService.addQuestionRule(questionRule).subscribe(questionRuleResult => {
        questionRule.questionRuleId = questionRuleResult.questionRuleId;
        resolve(questionRule);
      });
    });
  }

  updateQuestionRuleToDb(questionRule: QuestionRule) {
    this.questionRuleAPIService.updateQuestionRule(questionRule.questionRuleId, questionRule).subscribe();
  }

  deleteQuestionRuleToDb(questionRule: QuestionRule) {
    this.questionRuleAPIService.deleteQuestionRule(questionRule.questionRuleId).subscribe();
  }

  addOutcomeActionsToDb(assetInScene: AssetInScene, sceneAssetRelationPromise: Promise<SceneAssetRelation>) {
    sceneAssetRelationPromise.then(sceneAssetRelationResult => {
      ;
      if (assetInScene.outcomeActions) {
        assetInScene.outcomeActions.forEach(async outcomeAction => {
          if (!outcomeAction.outcomeActionId || outcomeAction.outcomeActionId == 0) {
            outcomeAction.sceneAssetRelationId = sceneAssetRelationResult.sceneAssetRelationId;
            await this.outcomeActionService.addOutcomesAction(outcomeAction);
          }
        });
      }
    })
  }

  updateAssetInDb(assetInScene: AssetInScene): Promise<BaseAsset> {
    let assetType = this.getType(assetInScene.baseAsset.assetTypeId);
    return new Promise((resolve) => {
      let assetToDb = this.deepCopyService.deepCopy(assetInScene.baseAsset);
      if (assetType == 'Video') {
        if (this.fileService.getObjectSrc('baseAsset', assetInScene.sceneAssetRelation.sceneAssetRelationId))
          assetToDb.src = this.fileService.getObjectSrc('baseAsset', assetInScene.sceneAssetRelation.sceneAssetRelationId);
      }
      this.assetAPIService.updateAsset(assetToDb, assetType).subscribe(assetResult => {
        if (assetType == 'Question') {
          this.updateQuestionResponses(assetInScene);
        }
        resolve(assetResult as BaseAsset);
      },
      err => {
        resolve(null);
      });
    });
  }

  addOrUpdateSceneAssetRelation(assetInScene): Promise<SceneAssetRelation> {
    return new Promise((resolve, reject) => {
      this.getSceneAssetRelationsFromDb().then(sceneAssetRelations => {
        if (this.isSceneAssetRelationInDb(sceneAssetRelations, assetInScene.sceneAssetRelation.sceneAssetRelationId)) {
          resolve(this.updateSceneAssetRelation(assetInScene.sceneAssetRelation, this.getType(assetInScene.baseAsset.assetTypeId)));
        } else {
          // this is called if the asset is added via the asset management page for the first time - the baseAsset exists in the db, but the sceneAssetRelation doesn't
          resolve(this.addSceneAssetRelationToDb(assetInScene, assetInScene.baseAsset));
          // this.addEventsAndEventRelationsToDb(assetInScene, sceneAssetRelationPromise);
        }
      });
    });
  }

  addVrEventToDb(assetEvent: AssetEvent, sceneAssetRelationPromise: Promise<SceneAssetRelation>): Promise<VrEvent> {
    return new Promise((resolve, reject) => {
      let oldSceneAssetRelationId: number = assetEvent.sceneAssetRelationId;
      sceneAssetRelationPromise.then(sceneAssetRelationResult => {
        assetEvent.sceneAssetRelationId = sceneAssetRelationResult.sceneAssetRelationId;
        if (assetEvent.linkedContentId == oldSceneAssetRelationId) {
          assetEvent.linkedContentId = sceneAssetRelationResult.sceneAssetRelationId;
        }
        this.VrEventAPIService.addVrEvent(assetEvent).subscribe(VrEventInDb => {
          assetEvent.vrEventId = VrEventInDb.vrEventId;
          resolve(VrEventInDb);
        },
        err => {
          resolve(null);
        });
      });
    });
  }

  addVrEventToDbWithoutPromise(assetEvent: AssetEvent): Promise<VrEvent> {
    return new Promise((resolve, reject) => {
      this.VrEventAPIService.addVrEvent(assetEvent).subscribe(VrEventInDb => {
        assetEvent.vrEventId = VrEventInDb.vrEventId;
        resolve(VrEventInDb);
      },
      err => {
        resolve(null);
      });
    });
  }

  addVrEventAssetRelationToDb(assetEvent, VrEventPromise): Promise<VrEventAssetRelation> {
    return new Promise<VrEventAssetRelation>((resolve) => {
      VrEventPromise.then(VrEventInDb => {
        var VrEventAssetRelation: VrEventAssetRelation = this.setVrEventAssetToResult(assetEvent, VrEventInDb);
        this.VrEventAssetRelationAPIService.addVrEventAssetRelation(VrEventAssetRelation).subscribe((VrEventAssetRelationFromDb) => {
          resolve(VrEventAssetRelation);
        },
        err => {
          resolve(null);
        });
      });
    });
  }

  addQuestionResponsesToDb(assetInScene, baseAssetId) {
    assetInScene.baseAsset.responses.filter(r => r.toBeRemoved !== true).forEach(async (response, index) => {
      await this.addQuestionResponseAssetsToDb(response);

      let responseToDb = this.deepCopyService.deepCopy(response);
      responseToDb.questionAssetId = baseAssetId;
      responseToDb.questionResponseId = 0;
      responseToDb.questionResponseIndex = index;

      this.responseAPIService.addQuestionResponse(responseToDb).subscribe(responseResult => {
        response.questionAssetId = baseAssetId;
        response.questionResponseId = responseResult.questionResponseId;
        response.assets.filter(a => a.toBeRemoved !== true).forEach(async (assetInQuestionResponse, index) => {
          this.addOrReturnAssetInQuestionResponse(assetInQuestionResponse, response, index);
        });
      });
    });
  }


  addSceneAssetRelationToDb(assetInScene, assetResult): Promise<SceneAssetRelation> {
    return new Promise((resolve, reject) => {
      this.setAssetInSceneToAssetResult(assetInScene, assetResult);
      var assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
      this.sceneAssetRelationAPIService.addRelation(assetInScene.sceneAssetRelation, assetType).subscribe(sceneAssetRelationResult => {
        assetInScene.sceneAssetRelation.sceneAssetRelationId = sceneAssetRelationResult.sceneAssetRelationId;
        resolve(sceneAssetRelationResult as SceneAssetRelation);
      },
      err => {
        resolve(null);
      });
    });
  }

  async updateQuestionResponses(assetInScene: AssetInScene) {
    let questionAsset = assetInScene.baseAsset as QuestionAsset

    for (var i: number = 0; i < questionAsset.responses.length; i++) {
      let response = questionAsset.responses[i];
      response.questionAssetId = questionAsset.baseAssetId;
      let responseToDb: QuestionResponse = this.deepCopyService.deepCopy(response);
      responseToDb.questionResponseIndex = i;

      if (!responseToDb.questionResponseId && responseToDb.toBeRemoved !== true) {
        await this.addQuestionResponseAssetsToDb(response);

        responseToDb = this.deepCopyService.deepCopy(response);
        responseToDb.questionAssetId = questionAsset.baseAssetId;
        responseToDb.questionResponseId = 0;
        responseToDb.questionResponseIndex = i;
        this.responseAPIService.addQuestionResponse(responseToDb).subscribe(responseResult => {
          response.questionResponseId = responseResult.questionResponseId;
          response.assets.filter(a => a.toBeRemoved !== true).forEach((assetInQuestionResponse, index) => {
            this.addOrReturnAssetInQuestionResponse(assetInQuestionResponse, response, index);
          });
        });

      } else if (responseToDb.questionResponseId && responseToDb.toBeRemoved === true) {
        this.responseAPIService.deleteQuestionResponse(responseToDb.questionResponseId).subscribe();
        this.deleteAssetsInQuestionResponse(responseToDb);
      } else {
        for (let j: number = 0; j < response.assets.length; j++) {
          let assetInQuestionResponse = response.assets[j];
          if (this.shouldAssetBeRemoved(assetInQuestionResponse)) {
            this.deleteAssetInQuestionResponseWithSceneAssetRelationId(assetInQuestionResponse);
          } else if (!assetInQuestionResponse.toBeRemoved) {
            await this.addOrUpdateQuestionResponseAssetToDb(response, assetInQuestionResponse);
            this.addOrReturnAssetInQuestionResponse(assetInQuestionResponse, response, j);
          }
        }
        this.responseAPIService.updateQuestionResponse(responseToDb.questionResponseId, responseToDb).subscribe();
      }
    }
  }

  addQuestionResponseAssetsToDb(response: QuestionResponse): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      for (let i: number = 0; i < response.assets.length; i++) {
        let assetInQuestionResponse = response.assets[i];

        if (assetInQuestionResponse.toBeRemoved === true) continue;

        await this.addOrUpdateQuestionResponseAssetToDb(response, assetInQuestionResponse);
      }

      resolve();
    });
  }

  addOrUpdateQuestionResponseAssetToDb(response: QuestionResponse, assetInQuestionResponse: AssetInScene): Promise<void> {
    return new Promise<void>((resolve) => {
      let assetInQuestionResponseType = this.getType(assetInQuestionResponse.baseAsset.assetTypeId);
      this.addOrUpdateAsset(assetInQuestionResponse).then(sceneAssetRelation => {
        assetInQuestionResponse.baseAsset.baseAssetId = sceneAssetRelation.baseAssetId;
        assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId = sceneAssetRelation.sceneAssetRelationId;
        switch (assetInQuestionResponseType) {
          case 'Image': {
            response.imageSceneAssetRelationId = sceneAssetRelation.sceneAssetRelationId;
            break;
          }
          case 'Video': {
            response.videoSceneAssetRelationId = sceneAssetRelation.sceneAssetRelationId;
            break;
          }
          case 'Audio': {
            response.audioSceneAssetRelationId = sceneAssetRelation.sceneAssetRelationId;
            break;
          }
        }
        resolve();
      });
    });
  }

  getSceneAssetRelationsFromDb(): Promise<SceneAssetRelation[]> {
    var sceneIds = this.getIds(this.scenes, 'sceneId');
    return new Promise((resolve, reject) => {
      this.sceneAssetRelationAPIService.getSceneAssetRelationsWithSceneIds(sceneIds).subscribe(sceneAssetRelations => {
        resolve(sceneAssetRelations as SceneAssetRelation[]);
      },
      err => {
        resolve([]);
      });
    })
  }

  isSceneAssetRelationInDb(sceneAssetRelations, sceneAssetRelationId) {
    var sceneAssetRelationIds = this.getIds(sceneAssetRelations, 'sceneAssetRelationId');
    return sceneAssetRelationIds.includes(sceneAssetRelationId);
  }

  updateSceneAssetRelation(sceneAssetRelation: SceneAssetRelation, assetType: string): Promise<SceneAssetRelation> {
    return new Promise((resolve, reject) => {
      this.sceneAssetRelationAPIService.updateRelation(sceneAssetRelation, assetType).subscribe(relation => {
        resolve(sceneAssetRelation);
      },
      err => {
        resolve(null);
      });
    });
  }

  setVrEventAssetToResult(assetEvent: AssetEvent, VrEventInDb): VrEventAssetRelation {

    var VrEventAssetRelation: VrEventAssetRelation = {
      'sceneAssetRelationId': assetEvent.sceneAssetRelationId,
      'vrEventId': VrEventInDb.vrEventId,
      'vrEventAssetRelationId': 0
    };

    return VrEventAssetRelation;
  }

  setAssetInSceneToAssetResult(assetInScene, assetResult) {
    assetInScene.baseAsset.baseAssetId = assetResult.baseAssetId;
    assetInScene.sceneAssetRelation.baseAssetId = assetResult.baseAssetId;
    assetInScene.sceneAssetRelation.sceneAssetRelationId = 0;
  }


  getQuestionResponseId(responses: QuestionResponse[]): number[] {
    var responseIds: number[] = [];
    responses.forEach(response => {
      responseIds.push(response.questionResponseId);
    })
    return responseIds;
  }

  async deleteAsset(asset: AssetInScene) {
    await this.deleteAssetEvents(asset);
    return this.deleteAssetAndSceneAssetRelationFromDb(asset);
  }

  deleteAssetEvents(asset: AssetInScene): Promise<void> {
    return new Promise(async (resolve) => {
      for(let i: number = 0; i < asset.events.length; i++){
        let element = asset.events[i];
        await this.VrEventAPIService.deleteVrEvent(element.vrEventId);
      }
      resolve();
    });
  }

  deleteAssetAndSceneAssetRelationFromDb(asset) {
    // if asset is a question      
    if (asset.baseAsset.responses) {
      asset.baseAsset.responses.forEach(response => {
        this.deleteAssetsInQuestionResponse(response);
      });
    }
    // if asset is not on asset management page, delete the asset which will cascade and remove the sceneAssetRelation
    this.assetManagePageAPIService.GetAssetOnAssetManagementPagesWithBaseAssetId(asset.baseAsset.baseAssetId).subscribe(assetManagementPage => {
      if (assetManagementPage == null) {
        return this.assetAPIService.deleteBaseAsset(asset.baseAsset.baseAssetId).toPromise();
      }
      else if (this.sceneAssetRelationAPIService.sceneAssetRelationExists(asset.sceneAssetRelation.sceneAssetRelationId)) {
        return this.sceneAssetRelationAPIService.deleteSceneAssetRelation(asset.sceneAssetRelation.sceneAssetRelationId).toPromise();
      }
    });
  }

  addAssetInBaseAssetToDb(assetInBaseAsset: AssetInBaseAsset): Promise<AssetInBaseAsset> {
    return new Promise((resolve, reject) => {
      this.assetInBaseAssetAPIService.addAssetInBaseAsset(assetInBaseAsset).subscribe(assetInBaseAssetResult => {
        resolve(assetInBaseAssetResult);
      },
      err => {
        resolve(null);
      })
    });
  }

  updateAssetInBaseAssetToDb(assetInBaseAsset: AssetInBaseAsset): Promise<AssetInBaseAsset> {
    return new Promise((resolve, reject) => {
      this.assetInBaseAssetAPIService.updateAssetInBaseAsset(assetInBaseAsset.assetInBaseAssetId, assetInBaseAsset).subscribe(assetInBaseAssetResult => {
        resolve(assetInBaseAssetResult);
      },
      err => {
        resolve(null);
      });
    });
  }

  deleteAssetInBaseAsset(assetInScene: AssetInScene): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      if (!assetInScene.baseAsset.baseAssetId) {
        resolve(true);
        return;
      }

      var assetsInBaseAsset = await this.assetInBaseAssetAPIService.getAssetsInBaseAssetWithBaseAssetId(assetInScene.baseAsset.baseAssetId).toPromise();
      if (assetsInBaseAsset.length > 0) {
        this.assetInBaseAssetAPIService.deleteAssetInBaseAsset(assetsInBaseAsset[0].assetInBaseAssetId).subscribe(result => {
          resolve(true);
        },
        err => {
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }

  addAssetInQuestionResponseToDb(assetInQuestionResponse: AssetInQuestionResponse): Promise<AssetInQuestionResponse> {
    return new Promise((resolve, reject) => {
      this.assetInQuestionResponseAPIService.addAssetInQuestionResponse(assetInQuestionResponse).subscribe(assetInQuestionResponseResult => {
        resolve(assetInQuestionResponseResult);
      },
      err => {
        resolve(null);
      });
    });
  }

  deleteAssetsInQuestionResponse(questionResponse: QuestionResponse): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      this.assetInQuestionResponseAPIService.deleteAssetInQuestionResponseWithLinkedQuestionResponseId(questionResponse.questionResponseId).subscribe(result => {
        questionResponse.assets.forEach(async (assetInQuestionResponse) => {
          await this.deleteAsset(assetInQuestionResponse);
        });
        resolve(true);
      },
      err=> {
        resolve(true);
      });
    });
  }

  deleteAssetInQuestionResponseWithSceneAssetRelationId(asset: AssetInScene): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      this.assetInQuestionResponseAPIService.getAssetsInQuestionResponseWithSceneAssetRelationId(asset.sceneAssetRelation.sceneAssetRelationId).subscribe(result => {
        if (result && result.length > 0) {
          let assetInQuestionResponse = result[0];
          this.assetInQuestionResponseAPIService.deleteAssetInQuestionResponse(assetInQuestionResponse.assetInQuestionResponseId).subscribe();
          //this.deleteAsset(asset);
        }
        resolve(true);
      },
      err =>{
        reject(err);
      });
    });
  }

  shouldAssetBeRemoved(asset: AssetInScene): boolean {
    return (asset.baseAsset.baseAssetId && asset.toBeRemoved);
  }

  getAssetsToBeRemoved(assetsInScene: AssetInScene[]): AssetInScene[] {
    var assetsToBeRemoved: AssetInScene[] = [];

    for (let i: number = 0; i < assetsInScene.length; i++) {
      let assetInScene = assetsInScene[i];
      let assetType = this.getType(assetInScene.baseAsset.assetTypeId);

      if (assetInScene.toBeRemoved == true) {
        assetsToBeRemoved.push(assetInScene);
      } else {
        if (assetType == 'Question') {
          let questionAsset = assetInScene.baseAsset as QuestionAsset;

          for (let r: number = 0; r < questionAsset.responses.length; r++) {
            let response = questionAsset.responses[r];
            for (let j: number = 0; j < response.assets.length; j++) {
              let assetInResponse = response.assets[j];

              if (assetInResponse.toBeRemoved == true) {
                assetsToBeRemoved.push(assetInResponse);
              }
            }
          }
        }
      }

      if (assetInScene.assets) {
        for (let j: number = 0; j < assetInScene.assets.length; j++) {
          let assetInAsset = assetInScene.assets[j];
          let assetInAssetType = this.getType(assetInAsset.baseAsset.assetTypeId);

          if (assetInAsset.toBeRemoved == true) {
            assetsToBeRemoved.push(assetInAsset);
          } else {
            if (assetInAssetType == 'Question') {
              let questionAsset = assetInAsset.baseAsset as QuestionAsset;

              for (let r: number = 0; r < questionAsset.responses.length; r++) {
                let response = questionAsset.responses[r];
                for (let k: number = 0; k < response.assets.length; k++) {
                  let assetInResponse = response.assets[k];

                  if (assetInResponse.toBeRemoved == true) {
                    assetsToBeRemoved.push(assetInResponse);
                  }
                }
              }
            }
          }
        }
      }
    }

    return assetsToBeRemoved;
  }

  getType(id) {
    return this.assetTypeService.getType(id);
  }

  getIds(array, param): number[] {
    var ids: number[] = [];
    array.forEach(element => {
      ids.push(element[param]);
    })
    return ids;
  }
}
